export var IDENTIFIER_IMAGE = 'image';
